import { useEffect, useState } from "react";
import axios from "axios";
import { Star, UserRound } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ReviewsSection = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/public/reviews`).then((r) => setItems(r.data || [])).catch(() => {});
  }, []);

  if (!items.length) return null;
  const avg = items.reduce((a, r) => a + r.rating, 0) / items.length;

  return (
    <section id="depoimentos" className="py-20 bg-slate-100" data-testid="reviews-section">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-extrabold mb-4 text-slate-900">O que dizem nossos hóspedes</h2>
          <p className="text-slate-500 flex items-center justify-center gap-2" data-testid="reviews-average">
            <Star className="w-5 h-5 fill-yellow-400 text-yellow-400" />
            <strong className="text-slate-800">{avg.toFixed(1)}</strong> de média em {items.length} avaliação(ões)
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {items.map((t) => (
            <div key={t.id} className="bg-white p-8 rounded-3xl shadow-sm border-l-8 border-[#0A66C2]" data-testid={`public-review-${t.id}`}>
              <div className="flex gap-1 text-yellow-500 mb-4">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} className={`w-4 h-4 ${j < t.rating ? "fill-current" : "text-slate-300"}`} />
                ))}
              </div>
              <p className="text-slate-700 text-base sm:text-lg mb-6 leading-relaxed">"{t.comment}"</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-slate-200 rounded-full flex items-center justify-center text-slate-500">
                  <UserRound className="w-5 h-5" />
                </div>
                <span className="font-bold text-slate-800 text-sm">— {t.name}{t.city ? `, ${t.city}` : ""}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
